import { Button } from '~/components/ui/button';
import type { DateFilterPreset } from '~/types';
import { cn } from '~/lib/utils';

interface IDateFilterBarProps {
  presets?: DateFilterPreset[];
  value: DateFilterPreset;
  onChange: (preset: DateFilterPreset) => void;
}

const PRESET_LABELS: Record<DateFilterPreset, string> = {
  all: 'All time',
  today: 'Today',
  '7d': '7D',
  '14d': '14D',
  '1m': '1M',
  '3m': '3M',
  '6m': '6M',
  '12m': '12M',
  custom: 'Custom',
};

const DEFAULT_PRESETS: DateFilterPreset[] = ['all', 'today', '7d', '14d', '1m', '3m', '6m', '12m'];

export const DateFilterBar = ({ presets = DEFAULT_PRESETS, value, onChange }: IDateFilterBarProps) => {
  return (
    <div className="flex items-center gap-1">
      {presets.map((preset) => (
        <Button
          key={preset}
          variant={value === preset ? 'default' : 'ghost'}
          size="sm"
          className={cn('h-8 px-3 text-xs font-medium', value !== preset && 'text-muted-foreground')}
          onClick={() => onChange(preset)}
        >
          {PRESET_LABELS[preset]}
        </Button>
      ))}
    </div>
  );
};
